/* eslint-disable @typescript-eslint/no-explicit-any */

import { Load } from "@/components/load";
import PageError from "@/components/page-error";
import { useGetAllTermsQuery } from "@/services/generate-term/generate-term";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { columns } from "../components/columns";
import { DataTable } from "../components/data-table";
import { useFilterState } from "../ducks/filter/hooks/filterState";

export function TermValidationList() {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const {
    data: terms,
    isLoading,
    isFetching,
    error,
  } = useGetAllTermsQuery({
    search: filters.search || "",
    store_code: filters.store || "",
    status: filters.status || "",
    reason: filters.reason || "",
    sla_status: filters.sla_status || "",
    start_date: filters.start_date || "",
    end_date: filters.end_date || "",
    orderBy: JSON.stringify(filters.orderBy || {}),
    perPage: filters.meta?.perPage || 10,
    meta: {
      page: filters.meta?.page || 1,
    },
  });

  if (isLoading) return <Load />;

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-white to-gray-50">
        <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />
      </div>
    );
  }

  const { data, meta } = terms || { data: [], meta: {} };

  return (
    <PageLayout>
      <PageTitle
        title="Validação de Termos"
        description="Gerencie e valide os termos pendentes de aprovação"
      />
      <ContentContainer>
        <DataTable data={data as any} columns={columns} meta={meta} isLoading={isFetching} />
      </ContentContainer>
    </PageLayout>
  );
}